import services from '../services'
import * as types from './mutation-types'

export const getList = ({ commit }, roomId, params) => (
  services.list(params, roomId).then(res => {
    commit(types.SET_CALL_ACTION, res.data)
  })
)

export const show = async ({ commit }, params) => {
  await services.find(params).then(res => {
    commit(types.SET_CALL_ACTION, res.data.data)
  })
}

export const save = async ({ commit }, obj) => {
  await services.save(obj).then(res => {
    commit(types.SET_CALL_ACTION, res.data)
    return res
  })
}
